const initialState = {
  customers: [],
  customersForOrder: [],
  total_pages: 0,
  closeModal: false,
  selected: false
};

const customersReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CUSTOMERS_FOR_ORDERS':
      return {
        ...state,
        customersForOrder: action.data.customers
      };
    case 'TOGGLE_MODAL':
      return {
        ...state,
        closeModal: action.data.toggle
      };
    case 'SET_CUSTOMERS_INDEX':
      return {
        ...state,
        customers: action.data.customers
      };
    case 'CREATE_CUSTOMER_FROM_CHAT':
      return {
        ...state,
        customer: action.data.customer,
        selected: action.data.selected
      };
    default:
      return state;
  }
};

export default customersReducer;
